<script setup lang="ts">
import VirtualViewportDemo from './VirtualViewportDemo.vue';

</script>

<template>
  <VirtualViewportDemo></VirtualViewportDemo>
</template>
